import React, { useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/* Small "Test email" tool (moved from the old Email Diagnostic tab; same POST /api/admin/test-email). */
export function TestEmailTool({ token }) {
  const [to, setTo] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const send = async () => {
    setBusy(true); setError(''); setResult(null);
    try {
      const res = await axios.post(`${API}/api/admin/test-email`, { to: to.trim() || undefined }, { headers: { Authorization: `Bearer ${token}` } });
      setResult(res.data);
    } catch (e) {
      setError(e.response?.data?.detail || 'Failed to send test email.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-diagnostic-card admin-test-email" data-testid="admin-test-email-card">
      <h3 className="admin-diagnostic-title">Test email</h3>
      <p className="admin-diagnostic-help">
        Sends a test email through Resend. Leave empty to use <code>ADMIN_NOTIFICATION_EMAIL</code> on this deployment.
      </p>
      <div className="admin-diagnostic-form">
        <input type="email" placeholder="Send to (optional)" value={to} onChange={(e) => setTo(e.target.value)} className="admin-search-input" data-testid="admin-diagnostic-to" />
        <button className="admin-action-btn admin-refresh-btn" onClick={send} disabled={busy} data-testid="admin-diagnostic-send">
          {busy ? <Loader2 className="admin-spinner" size={14} /> : 'Send test email'}
        </button>
      </div>
      {error && <p className="admin-error" data-testid="admin-diagnostic-error">{error}</p>}
      {result && (
        <div className="admin-diagnostic-result" data-testid="admin-diagnostic-result">
          <p className="admin-diagnostic-success">{result.message}</p>
          <ul className="admin-diagnostic-meta">
            <li><strong>ADMIN_NOTIFICATION_EMAIL:</strong> <code>{result.admin_notification_email_on_deployment || '(not set)'}</code></li>
            <li><strong>Sender (FROM):</strong> <code>{result.sender}</code></li>
            <li><strong>Resend API configured:</strong> {result.resend_api_configured ? 'yes' : 'no'}</li>
          </ul>
        </div>
      )}
    </div>
  );
}
